import React from "react";
import { Modal } from "lib/components/index";

import st from "lib/utils/index";

const ConfirmSlotWithOrWithoutFutureModal = ({
  modalRef,
  resolve,

  header,
  content,
  mainConfirmButton,
  subConfirmButton,
  cancelButton = I18n.t("papp.common.cancel"),

  ...props
}) => (
  <Modal closeIcon closeOnDimmerClick={false} ref={modalRef} {...props}>
    <Modal.Header>{header}</Modal.Header>,<Modal.Content>{content}</Modal.Content>,
    <Modal.Actions>
      <a className="ui button" onClick={() => resolve()}>
        {cancelButton}
      </a>
      {!!mainConfirmButton && (
        <a className="ui button primary right floated" onClick={() => resolve({ mainConfirm: true })}>
          {mainConfirmButton}
        </a>
      )}
      {!!subConfirmButton && (
        <a className="ui button basic primary right floated" onClick={() => resolve({ mainConfirm: false })}>
          {subConfirmButton}
        </a>
      )}
    </Modal.Actions>
  </Modal>
);

export default function createConfirmSlotWithOrWithoutFutureModal(props) {
  return st.createModal(ConfirmSlotWithOrWithoutFutureModal, props);
}



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/StepAvailability/ConfirmSlotWithOrWithoutFutureModal.jsx